// extracted by mini-css-extract-plugin
export default {"userMenuBlock":"NotificationsUser_userMenuBlock__OMy1H"};